// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"26d388f2","453":"5242dc14","455":"03dd9033","461":"4ccc66ee"}[chunkId] + ".chunk.js";
};